var Conversations = new (class Conversations extends AbstractModule {

  constructor() {
    super("Conversations");
    this.displayDelayOnOpen = 300;
    this._cache = {};
    this._temp_conversation = null;
    this._currently_displayed = null;
    this._new_locked = false;
    this._summaryDisplays = [];
    this._warned_team_unavailable = false;
    this._user_committed_to_new_conversation = false;
    this._message_placeholders = [
      { placeholder: '{{generating}}', wordingKey: 'ai_generating', blinking: true },
      { placeholder: '{{searching}}', wordingKey: 'ai_searching', blinking: true },
      { placeholder: '{{moderated}}', wordingKey: 'content_moderated', blinking: false },
      { placeholder: '{{moderated_reply}}', wordingKey: 'content_moderated_reply', blinking: false },
    ]
  }

  _initData(data) {
    let conversations = {};
    if (data.guest.messages) {
      let keys = Object.keys(data.guest.messages);
      keys.forEach(key => {
        conversations[key] = this._newConversation(data.guest.messages[key]);
      })
    }

    this._autoInit({
      "_list": [ conversations, {} ]
    });
  }

  _closeOpenEphemeralConversations() {
    const toClose = [];
    this.forEach(conv => {
      if (conv && conv.ephemeral && conv.id && conv.isOpened()) toClose.push(conv);
    });
    if (toClose.length === 0) return;
    toClose.forEach(conv => {
      this._closeEphemeralConversation(conv, { useBeacon: true });
    });
  }

  _closeEphemeralConversation(conv, { useBeacon = false } = {}) {
    if (!conv || !conv.ephemeral || !conv.id) return;
    const payload = {
      key: this.app._api_key,
      token: this.app._guest_token,
      current_conversation_id: conv.id
    };

    if (useBeacon) {
      const baseUrl = this.app._post_url;
      if (!baseUrl) return;
      const body = new Blob([JSON.stringify(payload)], { type: 'text/plain' });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(baseUrl + '/api/close_conversation', body);
      }
      return;
    }

    Ajax.call('/api/close_conversation', payload);
  }

  _initAfterWidget() {
    this.subscribeSummaryList("slaask-widget-convpage-conversations", "slaask-conversation-", Infinity);
    window.addEventListener('beforeunload', () => this._closeOpenEphemeralConversations());
    window.addEventListener('pagehide', () => this._closeOpenEphemeralConversations());
    this.app.on('close', () => {
      const conv = this.current;
      if (conv && conv.ephemeral && conv.id) {
        const widgetWindow = Dom.get('widget') && Dom.get('widget').window;
        const callFrame = (widgetWindow && widgetWindow.callFrame) || (typeof window !== 'undefined' && window.top && window.top.callFrame);
        if (callFrame && typeof callFrame.leave === 'function') {
          try { callFrame.leave(); } catch (e) { /* ignore */ }
        }
        const iframeInfo = this.app._getDailyIframeInfo && this.app._getDailyIframeInfo();
        if (iframeInfo && iframeInfo.iframeView) {
          iframeInfo.iframeView.setContent('');
        }

        this._closeEphemeralConversation(conv);
        this.conversationClosed(conv, 'resolved', false);
        this._syncConversationSummary(conv);
        Views.jumpToViewByName('conversations');
      }
    });
  }

  _initAfterGuest() {
    if (this.canOpenNew())
      this._unlockNew();
    else
      this._lockNew();

    Views.when('ready').then(() => {
      this._syncSummaryListViewDisplay();
      this.forEach(conv => this._postInitMessagesTreatment(conv));
    });

    this._eventHappened('ready');
  }


  /* INIT */

  // Makes modifications to messages right after guest initialization
  _postInitMessagesTreatment(conversation) {
    let lastMessage = conversation.getLastMessage();
    for (let i = 0 ; i < conversation.messages.length ; i++) {
      let message = conversation.messages[i];

      if (message.text == "{xeno{email_asked}xeno}") {
        if (message != lastMessage || this.app._getEmail() && !Wording.email_asking_content_with_email) {
          conversation.messages.splice(i, 1);
          i--;
        }
      }
    }
    if (!conversation.isOpened()) {
      this._addClosedMessage(conversation);
    }
  }

  _addClosedMessage(conversation) {
    let message = new Message(MS.bot, Wording.md('closed_conversation_short_text') + " " + Svg.check());
    message.type = "notification";
    message.custom_class = "conversation-closed";
    conversation.addMessage(message, true);
  }

  _addReopenedMessage(conversation) {
    let message = new Message(MS.bot, Wording.md('reopened_conversation_text'));
    message.type = "notification";
    conversation.addMessage(message, true);
  }

  // Called after user_infos has been fetched, look for every variables in conversations & in DOM
  _parseVariables() {
    // TODO
  }


  /* NOT SORTED */

  _newConversation(data) {
    let conversation = new Conversation(data);
    MessageException.process(conversation.messages);
    this._initConversationEvents(conversation);
    requestAnimationFrame(() => {
      this._syncConversationSummary(conversation);
      this._initConversationLifeSpan(conversation);
    });
    this.initializeAttachments(conversation.messages);
    Utils.emptyCache('conversations');
    this._trigger('new-conversation', conversation);
    return conversation;
  }

  _initConversationEvents(conversation) {
    conversation.on('user_typing', typingData => {
      this._userTyping(conversation, typingData);
    });
    conversation.on('user_stopped_typing', typingData => {
      this._userStoppedTyping(conversation, typingData);
    });
    conversation.on('new_message', (message, silent) => {
      this._addMessage(message, silent);
    });
    conversation.on('remove_message', message => {
      this._removeMessage(message);
    });
    conversation.on('submit_to_changed', submit_to => {
      if (this.current == conversation) {
        this._syncFileSharingDisplay();
      }
    });
    conversation.on('bot_tree_running_changed', bot_tree_running => {
      if (this.current == conversation) {
        this._syncFileSharingDisplay();
      }
    });
    conversation.on('reorder_message', message => {
      this._reorderMessage(message);
    });
  }

  open(conversationOrId) {
    Views.jumpToViewByName('conversation',  conversationOrId.constructor == Conversation
                                            ? conversationOrId.id
                                            : conversationOrId);
  }

  _open(conversationOrId) {
    let conversation = this._conversationOrId(conversationOrId);

    let currentGroup  = Teams.findOrDefault(parseInt(conversation.user_group_id));

    if(currentGroup) {

      if(currentGroup.kind == 'many') {
        this.app._setManyToManyChannel(conversation);

        Dom.findById('widget', 'slaask-widget-header-back').addEventListener('click', this.app._removeManyToManyChannel);
      }
    }

    this._syncFileSharingDisplay();

    if (this.app._ai_warning_modal_enabled) {
      const warningText = this.app._ai_warning_text || 'Ce chatbot IA peut se tromper. Veuillez vérifier ses réponses.';
      const escapedText = warningText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      Views.getByName('conversation').setContent(`
        <ul id="conversation-list" class="slaask-messages" aria-live="polite" role="log"></ul>
        <div class="slaask-ai-warning">
          <span style="font-size: 12px;">${escapedText}</span>
          <a href="javascript:void(0)">
            ${Svg.getIcon('chevronRight', { size: '10px', height: '10px' })}
          </a>
        </div>`);
    } else {
      Views.getByName('conversation').setContent(`
        <ul id="conversation-list" class="slaask-messages" aria-live="polite" role="log"></ul>
        <div class="slaask-whitelabel">
          ${this.app._whitelabel_html}
        </div>`);
    }

    Utils.uniqueTimeout('conversation-display', () => {
      this._displayConversation(conversation);
    }, this.displayDelayOnOpen);

    // Start bot tree or create conversation on server when temp (e.g. ephemeral from menu)
    if (conversation.id == null && this._shouldAutoStartOnOpen()) {
      if (this.waitingForBotTree(conversation)) {
        this._startBotTree(conversation);
      } else {
        this._createTempConversationOnServer(conversation);
      }
    }
  }

  _shouldAutoStartOnOpen () {
    if (Homepage.skipsToConversationsOnly()) {
      return this._user_committed_to_new_conversation;
    }

    return this.didUserCommitToNewConversation();
  }

  async _createTempConversationOnServer(conversation) {
    try {
      await this._awaitWsConnected();
    } catch (e) {
      this._handleStartConversationFailure();
      return;
    }

    const requestHash = Utils.generateRandomToken(1);
    const handler = m => {
      if (m.detail.request_hash == requestHash) {
        this.app.off('hash_callback', handler);
        this._tempConversationBecomesReal(m.detail.conversation_id);
        this._syncConversationSummary(conversation);
      }
    };
    this.app.on('hash_callback', handler);

    try {
      await Ajax.call('/api/start_conversation', {
        request_hash: requestHash,
        ephemeral: !!conversation.ephemeral,
        context: {
          forced_user_group_id: this.app._forced_user_group_id || null
        }
      });
      this._syncInputDisplay();
    } catch (e) {
      this.app.off('hash_callback', handler);
      this._handleStartConversationFailure();
    }
  }

  userCommittedToNewConversation(startBotTree, conversation = this.current) {
    this._user_committed_to_new_conversation = true;
    this._syncInputDisplay();
    if (startBotTree && this.waitingForBotTree(conversation)) this._startBotTree(conversation);
  }

  didUserCommitToNewConversation() {
    return this._user_committed_to_new_conversation || !this.app._bot_tree_enabled;
  }

  waitingForBotTree(conversation) {
    if (!this.app._bot_tree_enabled) return null;
    else if (conversation.id == null) return true;
    else return false;
  }

  async _startBotTree(conversation) {
    try {
      await this._awaitWsConnected();
    } catch (e) {
      this._handleStartConversationFailure();
      return;
    }

    const requestHash = Utils.generateRandomToken(1);
    const handler = m => {
      if (m.detail.request_hash == requestHash) {
        this.app.off('hash_callback', handler);
        this._tempConversationBecomesReal(m.detail.conversation_id);
        this._syncConversationSummary(conversation);
      }
    };
    this.app.on('hash_callback', handler);
    this.app.on('show_message_input', () => {
      conversation._force_hide_message_input = false
      Views.syncInputDisplay();
    })
    this.app.on('hide_message_input', () => {
      conversation._force_hide_message_input = true
      Views.syncInputDisplay()
    })

    let triggerId = null;
    const messagesWithTrigger = conversation.messages.filter(message => message.trigger_id);
    if (messagesWithTrigger.length) {
      triggerId = messagesWithTrigger.pop().trigger_id;
    }

    try {
      const response = await Ajax.call('/api/start_conversation', {
        request_hash: requestHash,
        forced_bot_tree: conversation.forced_bot_tree || this.app._forced_bot_tree,
        auto_message: triggerId,
        ephemeral: !!conversation.ephemeral,
        context: {
          forced_user_group_id: this.app._forced_user_group_id || null
        }
      });
      this.app._triggerInternalEvent('bot_tree_started', {
        'conversation_id': response.conversation_id,
        'bot_tree': response.bot_tree
      });
      this._syncInputDisplay();
    } catch (e) {
      this.app.off('hash_callback', handler);
      this._handleStartConversationFailure();
    }
  }

  _awaitWsConnected(timeoutMs = 10000) {
    if (this.app.didEventHappen('ws_connected')) return Promise.resolve();
    return new Promise((resolve, reject) => {
      let settled = false;
      const timer = setTimeout(() => {
        if (!settled) {
          settled = true;
          reject(new Error('ws_connection_timeout'));
        }
      }, timeoutMs);
      this.app.when('ws_connected').then(() => {
        if (!settled) {
          settled = true;
          clearTimeout(timer);
          resolve();
        }
      });
    });
  }

  _handleStartConversationFailure() {
    this._user_committed_to_new_conversation = false;
    this._syncInputDisplay();
    this.app._disconnectChatbox();
  }

  canOpenNew() {
    return this.app._xeno || !this.last_private || !this.last_private.isOpened();
  }

  _unlockNew() {
    this._new_locked = false;
    const newConvLabel = Wording.new_conversation_text;
    const newConvLabelHomepage = this.app._homepage_texts['new_conversation'] || Wording.new_conversation_text;

    if (this.app._custom_cards.length === 0) {
      Views.when('ready').then(() => {
        Dom.findById('widget', 'slaask-widget-convpage-button').innerHTML = newConvLabel;
        Dom.findById('widget', 'slaask-widget-homepage-conv-button').innerHTML = newConvLabel;
      });
    } else {
      Views.when('ready').then(() => {
        const conversationButtons = Dom.findAll('widget', '.switch-view-block-conversation')

        conversationButtons.forEach((conversationButton) => {
          conversationButton.innerHTML = newConvLabelHomepage;
        })
      });
    }
  }

  _lockNew() {
    this._new_locked = true;

    if (this.app._custom_cards.length === 0) {
      Views.when('ready').then(() => {
        Dom.findById('widget', 'slaask-widget-convpage-button').innerHTML = Wording.back_to_chat;
        Dom.findById('widget', 'slaask-widget-homepage-conv-button').innerHTML = Wording.back_to_chat;
      });
    } else {
      Views.when('ready').then(() => {
        const conversationButtons = Dom.findAll('widget', '.switch-view-block-conversation')

        conversationButtons.forEach((conversationButton) => {
          conversationButton.innerHTML = this.app._homepage_texts['back_to_chat']
        })
      });
    }
  }

  clickOnCta() {
    if (this._new_locked && this.last_private) {
      Views.jumpToViewByName('conversation', this.last_private.id);
    }
    else {
      this.userCommittedToNewConversation();
      Views.jumpToViewByName('conversation', null);
    }
  }

  setCurrentConversationEphemeral() {
    const conversation = this.current;
    if (!conversation || conversation.ephemeral) return;
    if (!conversation.id) {
      conversation.ephemeral = true;
      const ephemeralBtn = Dom.findById('widget', 'slaask-file-btn-ephemeral');
      if (ephemeralBtn) ephemeralBtn.classList.add('slaask-hidden');
      Dom._syncHeaderEphemeralButton();
      this._syncFileSharingDisplay();
      if (Views.current && Views.current.name === 'conversation') {
        Views.syncTitle();
        Dom.smallTitle(Wording.new_ephemeral_conversation_text);
        this._syncInputPlaceholder();
      }
      return;
    }
    Ajax.call('/api/set_conversation_ephemeral', {
      key: this.app._api_key,
      token: this.app._guest_token,
      current_conversation_id: conversation.id
    }).then(() => {
      conversation.ephemeral = true;
      this._syncConversationSummary(conversation);
      const ephemeralBtn = Dom.findById('widget', 'slaask-file-btn-ephemeral');
      if (ephemeralBtn) ephemeralBtn.classList.add('slaask-hidden');
      Dom._syncHeaderEphemeralButton();
      this._syncFileSharingDisplay();
      if (Views.current && Views.current.name === 'conversation') {
        Views.syncTitle();
        Dom.smallTitle(Wording.new_ephemeral_conversation_text);
        this._syncInputPlaceholder();
      }

      conversation.addMessage(new Message(MS.support, Wording.md('new_ephemeral_conversation_confirmation')))
    });
  }

  _initConversationLifeSpan(conversation) {
    if (!conversation.isOpened()) return;

    let faqAsked      = false;
    let teamAsked     = false;
    let prechatAsked  = false;

    let onlineLifeSpan = async () => {
      try {
        conversation.life_span = Conversation.LIFE_SPAN.ONLINE;
        if (conversation.messages.length == 0 || !conversation.greeting_message) {
          this._displayGreetings(conversation, this.app.isLive() ? 'online' : 'offline');

          if (Faqs.enabled(this.app.isLive() ? 'online' : 'offline') && !faqAsked)
            faqAsked = await Faqs.enterState(conversation);

          teamAsked     = await Teams.enterState(conversation);
          prechatAsked  = await Prechat.enterState(conversation);

          if (prechatAsked)
            conversation.addMessage(new Message(MS.bot, Wording.md('prechat_questions_final_message')));
          else if (teamAsked)
            conversation.addMessage(new Message(MS.support, Wording.md('prechat_questions_final_message')));
          else if (faqAsked)
            conversation.addMessage(new Message(MS.bot, Wording.md('bot_live_start')));

        }

        await this.enterChatState(conversation);

        if (!conversation.ephemeral) await Surveys.enterState(conversation);
      }
      catch(e) {
        if (e == "switch_to_offline")
          offlineLifeSpan(true);
        else
          throw e;
      }
    };

    let offlineLifeSpan = async (fromOnline = false) => {
      conversation.life_span = Conversation.LIFE_SPAN.OFFLINE;
      if (fromOnline)
        conversation.addMessage(new Message(MS.bot, Wording.md('switch_to_offline_slaask')));
      else
        this._displayGreetings(conversation, 'offline');

      if (fromOnline) {
        if (Faqs.enabled('offline') && !faqAsked)
          conversation.addMessage(new Message(MS.bot, Wording.md('switch_to_offline_slaask_faq')));
        else if (this.app._offline_email_address)
          conversation.addMessage(new Message(MS.bot, Wording.md('switch_to_offline_slaask_email')));
      }

      if (Faqs.enabled('offline') && !faqAsked)
        faqAsked = await Faqs.enterState(conversation, 'offline');

      if (!prechatAsked)
        prechatAsked = await Prechat.enterState(conversation);

      if (this.app._offline_email_address || (this.app._ticketing_system_enabled || this.app._handle_delayed_by_email))
        this.displayOfflineForm(conversation);
      else
        this.conversationClosed(conversation, 'resolved');
    };

    let botTreeLifeSpan = async () => {
      conversation.life_span = Conversation.LIFE_SPAN.ONLINE;
      if (conversation.messages.length == 0 || !conversation.greeting_message) {
        this._displayGreetings(conversation, this.app.isLive() ? 'online' : 'offline');
      }

      await this.enterChatState(conversation);

      if (!conversation.ephemeral) await Surveys.enterState(conversation);
    };

    if (this.app._bot_tree_enabled) {
      botTreeLifeSpan();
    }
    else {
      if (!this.app.isLive()
          && conversation.messages.length == 0
          && (this.app._ticketing_system_enabled || this.app._handle_delayed_by_email))
        offlineLifeSpan();
      else
        onlineLifeSpan();
    }


    conversation.initLifeSpan();
  }

  _normalizeDate(dateValue) {
    if (!dateValue) return null;
    return typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
  }

  _getConversationCreatedAt(conversation) {
    return this._normalizeDate(conversation.created_at) 
      || this._normalizeDate(conversation.firstMessageDate) 
      || conversation._object_created_at;
  }

  _displayGreetings(conversation, which) {
    if (conversation.greeting_message) {
      return;
    }
    
    const triggers = Triggers.getTriggers();
    const activeMessageTrigger = triggers.find(trigger => 
      trigger.kind === 'message' && 
      (this.app.isLive() || trigger.offline_activated)
    );
    
    if (activeMessageTrigger) {
      const existingMessage = conversation.messages.find(msg => msg.trigger_id === activeMessageTrigger.id);
      if (existingMessage) {
        conversation.greeting_message = existingMessage;
        return;
      }
      
      const triggerMessages = typeof activeMessageTrigger.message === 'string' 
        ? JSON.parse(activeMessageTrigger.message) 
        : activeMessageTrigger.message;
      
      if (triggerMessages && triggerMessages.length > 0) {
        const firstTriggerMessage = triggerMessages[0];
        const messageText = typeof firstTriggerMessage === 'object' 
          ? firstTriggerMessage.message 
          : firstTriggerMessage;
        
        if (messageText) {
          let autoMessage = new Message(MS.bot, messageText);
          autoMessage.parser = Message.PARSER.HTML;
          autoMessage.trigger_id = activeMessageTrigger.id;
          
          const conversationCreatedAt = this._getConversationCreatedAt(conversation);
          
          if (conversationCreatedAt) {
            autoMessage.created_at_ts = Math.floor(conversationCreatedAt.getTime() / 1000);
            autoMessage.created_at = conversationCreatedAt.toISOString();
          }
          
          conversation.greeting_message = autoMessage;
          conversation.addMessage(autoMessage, true);
          conversation.reorderMessage(autoMessage, 0);
          return;
        }
      }
    }

    let message = new Message(Faqs.enabled('online') || which == 'offline' ? MS.bot : MS.support);
    message.text = which == 'online'
      ? Wording.md('greeting_message')
      : Wording.md('offline_greeting_message');
    
    const conversationCreatedAt = this._getConversationCreatedAt(conversation);
    
    if (conversationCreatedAt) {
      message.created_at_ts = Math.floor(conversationCreatedAt.getTime() / 1000);
      message.created_at = conversationCreatedAt.toISOString();
    }
    
    conversation.greeting_message = message;
    conversation.addMessage(message, true);
    conversation.reorderMessage(message, 0);
  }

  enterChatState(conversation) {
    conversation.submitTo('publish');
    return new Promise((resolve, reject) => {
      Utils.logState(conversation, 'Chat');
      conversation.storePromise(resolve, reject, 'chat');
    })
  }

  // Duplicated code. Can be deleted after full implementation of the bot tree
  displayOfflineForm(conversation) {
    clearTimeout(conversation.waiting_for_answer_timeout);
    let ticketing_system_html = '';

    if (this.app._ticketing_system_names != [] && this.app._ticketing_system_names != null) {
      let ticketing_system_options = '';

      for (var i = 0; i < this.app._ticketing_system_names.length; i++)
        ticketing_system_options += `<option value="${this.app._ticketing_system_names[i].id}">${this.app._ticketing_system_names[i].name}</option>`

      if (ticketing_system_options != '')
        ticketing_system_html = '<div><select id="slaask-offline-ticketing_system-input" name="ticketing" class="chat-input slaask-input-offline">' + ticketing_system_options + '</select></div>'
    }

    let subject_html = this.app._should_display_subject ? '<input id="slaask-object-input" name="subject" class="chat-input slaask-input-offline" placeholder="' + Wording.offline_object_content + '" type="text" required="required">' : ""

    let text = `
      <form class="slaask-offline-form">
        <input id="slaask-email-input" name="email" class="chat-input slaask-input-offline" value="${this.app._getEmail() || ''}" placeholder="${Wording.offline_email_content}" type="email" required="required" />
        ${subject_html}
        <div id="slaask-offline-form-error" class="slaask-offline-form-error"></div>
        ${ticketing_system_html}
        <textarea id="slaask-offline-message-input" name="text" class="chat-input slaask-input-offline" placeholder="${Wording.offline_message_content}" type="text" required="required"></textarea>
        <input class="slaask-btn" type="submit" value="${Wording.offline_submit_content}">
      </form>`;

    let message = new Message(MS.bot, text);
    // message.parser = Message.PARSER.HTML;
    message.type = "notification";
    message.focus = "#slaask-email-input";
    message.mandatory_buttons = true;

    message.addInteraction({
      selector: '.slaask-offline-form',
      event: 'submit',
      removeButtons: true,
      handler: e => {
        e.preventDefault();
        let email = e.currentTarget.email.value;
        let subject = e.currentTarget.subject ? e.currentTarget.subject.value : undefined;
        let ticketing = e.currentTarget.ticketing ? e.currentTarget.ticketing.value : null;
        let text = e.currentTarget.text.value;

        if (email.length > 0 && text.length > 0) {
          if (/^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
            Ajax.call('/api/send_email', {
              'key': this.app._api_key,
              'guest_id': this.app._guest_id,
              'email': email,
              'message': text,
              'ticketing_system_key': ticketing,
              'object': subject
            });

            message.parser = Message.PARSER.MARKDOWN;
            message.text = text;
            message.type = "message";
            this.updateMessage(message);

            let thanksMessage = new Message(MS.bot, `
              ${Wording.offline_submit_thanks
                ? Wording.md('offline_submit_thanks')
                : ``}
              <div class="slaask-btn">
                ${Wording.offline_submit_another_content}
              </div>
              `);
            thanksMessage.plain_text = Wording.offline_submit_thanks;
            thanksMessage.mandatory_buttons = true;

            thanksMessage.addInteraction({
              selector: '.slaask-btn',
              event: 'click',
              removeButtons: true,
              printResponse: e => e.currentTarget.innerHTML,
              handler: e => {
                this.displayOfflineForm(conversation);
              }
            });

            conversation.addMessage(thanksMessage);
          }
          else {
            message.querySelector('#slaask-offline-form-error').innerHTML = email + ' ' + Wording.email_not_valid;
            message.querySelector('#slaask-email-input').focus();
          }
        }
        else {
          Utils.warn("Email or text is empty");
          return false
        };
      }
    });
    conversation.addMessage(message);
  }

  // Callback when the conversation is closed on the server side
  conversationClosed(conversation, status, printClosed = true) {
    if (conversation) {
      if (conversation.isOpened() && conversation.kind != "many") {
        conversation.status = status || "resolved";
        if (printClosed) this._addClosedMessage(conversation);
        if (!this.app._xeno && this.unresolvedConversationsCount('one') == 0)
          this._unlockNew();
        Dom.switchFooter('footer');
      }
      conversation.resolvePromise(null, 'chat');
    }
  }

  conversationReopened(conversation, status, printClosed = true) {
    if (conversation) {
      if (!conversation.isOpened() && conversation.kind != "many") {
        conversation.status = "open";
        if (printClosed) this._addReopenedMessage(conversation);
        if (!this.app._xeno)
          this._lockNew();
        this._syncInputDisplay();
      }
      conversation.resolvePromise(null, 'chat');
    }
  }

  unresolvedConversationsCount(kind) {
    let count = 0;
    this.forEach(conversation => {
      if (conversation.isOpened() && (!kind || conversation.kind == kind))
        count++;
    });
    return count;
  }


  /* MESSAGES FLOW */

  /**
   * Parses the text from a message to get something displayable
   *
   * @param  {Message} message
   * @param  {Number} plainLevel  0 - Renders and format everything from message.text
   *                              1 - Renders and format everything from message.plain_text
   *                              2 - Only renders plain text without formatting from message.plain_text
   *                              true == 0, false == 2
   * @return {string}
   */
  getMessageContent(message, plainLevel = 0) {
    if (plainLevel === false) plainLevel = 0;
    if (plainLevel === true) plainLevel = 2;

    const replacedPlaceholders = this.replacePlaceholdersIfNeeded(message);

    return Utils.cacheSync('message-' + message.id, plainLevel, () => {
      let text = plainLevel >= 1 ? message.plain_text : message.text;
      let plain = plainLevel == 2;

      if (replacedPlaceholders) return text;

      if (message.translated && !message.translate_reversed && !plain && message.name != 'me')
        text = message.translated.text;

      if (message.parser == Message.PARSER.MARKDOWN)
        text = this.app._askTechParser.mdToHtml(text, plain);

      if ([Message.PARSER.MARKDOWN, Message.PARSER.HTML].includes(message.parser))
        text = this.app._askTechParser.htmlToDisplayable(text, plain);

      if (plainLevel == 0) {
        text += this.getTranslateHtml(message);
      }

      return text;
    });
  }

  replacePlaceholdersIfNeeded(message) {
    let replaced = false;

    Utils.forEach(this._message_placeholders, placeholder => {
      if (message.text == placeholder.placeholder) {
        if (placeholder.blinking) {
          message.text = message.text.replace(placeholder.placeholder, `<span class="slaask-text-blinking">${Wording[placeholder.wordingKey]}</span>`);
          
          replaced = true;
        } else {
          message.text = message.text.replace(placeholder.placeholder, Wording[placeholder.wordingKey]);
        }
      } else {
        message.text = message.text.replace(placeholder.placeholder, '');
        message.text = message.text.replace(`<span class="slaask-text-blinking">${Wording[placeholder.wordingKey]}</span>`, '');
      }
    });

    return replaced;
  }

  getTranslateHtml(message) {
    let html = '';
    if (message.translated && message.name != 'me') {
      if (message.translate_reversed) {
        html += `
          <p id="translated-label-${message.id}" class="translated-label">
            ${Svg.globe()}
            <span>
              ${Wording.show_translated.replace(/%{language}/, Wording.languages['language_' + message.translated.from])}
            </span>
          </p>`;
      } else {
        html += `
          <p id="translated-label-${message.id}" class="translated-label is-translated">
            ${Svg.globe()}
            <span>
              ${Wording.show_original}
            </span>
          </p>`;
      }
    }
    return html;
  }

  /**
   * Ensures Attachments synchronization between data model and the document elements
   * @param {Message[]} messages
   */
  initializeAttachments(messages) {
    if (!Array.isArray(messages)) messages = [messages];

    Utils.forEach(messages, message => {
      if (message.attachments) this.setAttachmentActions(message);
      message.on('attachments_updating', new_attachments => { this.removeAttachmentActions(message); });
      message.on('attachments_updated', new_attachments => { this.setAttachmentActions(message); });
    });
  }

  /**
   * Given the message.attachments, this method will generate the needed HTML
   * based on their types and options.
   * @param {Message} message
   * @returns {string} The HTML
   */
  getAttachmentHtml(message) {
    let html = '';
    Utils.forEach(message.attachments, attachment => {
      if (~["Attachment::PersistentButton", "Attachment::EphemeralButton"].indexOf(attachment.type)) {
        if (attachment.action.type == "link") {
          let target = attachment.action.options.target == 'self' ? (Dom.isInIframe() ? '_parent' : '_self') : '_blank';
          html += `<a href="${attachment.action.options.url}" target="${target}" id="asktech-attachment-${attachment.id}" class="asktech-btn" role="button" tabindex="0">
            <span>${this.app._askTechParser.mdToDisplayable(attachment.options.text, true)}</span>
            <span style="margin-left: 0.2em; opacity: 0.4;">${Svg.externalLink('currentColor', '0.8em')}</span>
          </a>`
        }
        else {
          html += `<div id="asktech-attachment-${attachment.id}" class="asktech-btn" role="button" tabindex="0">${this.app._askTechParser.mdToDisplayable(attachment.options.text, true)}</div>`
        }
      }
      else if (attachment.type == "Attachment::Input") {
        let type;
        if (attachment.options.type == 'number')
          type = 'number';
        else if (attachment.options.field == 'email')
          type = 'email';
        else
          type = 'text';
        html += `
          <form class="asktech-input-attachment-layout" id="asktech-input-attachment-${attachment.id}">
            <input class="slaask-input asktech-empty" placeholder="${attachment.options.placeholder}" type="${type}" name="${attachment.options.field || ''}" />
            <button>${Svg.send()}</button>
          </form>`;
      }

      else if (attachment.type == "Attachment::Rating") {
        const data = (attachment.action && attachment.action.options && attachment.action.options.data) || {};
        const optSurvey = (attachment.options && attachment.options.survey) || {};
        const fourChoices = data.four_choices === true || data.four_choices === 'true'
          || optSurvey.four_choices === true || optSurvey.four_choices === 'true';
        const ratingValues = fourChoices ? [5, 4, 2, 1] : [5, 4, 3, 2, 1];

        let radio = (value, checked) => {
          let emoji= ""
          switch(value){
            case 1:
              emoji= `${this.app._cdn_url}/1f620.png`
            break
            case 2:
              emoji= `${this.app._cdn_url}/1f641.png`
            break
            case 3:
              emoji= `${this.app._cdn_url}/1f610.png`
            break
            case 4:
              emoji= `${this.app._cdn_url}/1f642.png`
            break
            case 5:
              emoji= `${this.app._cdn_url}/1f60d.png`
            break

          }
          return `
            <input id="rate_${value}" name="slaask-rating-survey-input" type="radio" required value="${value}"${checked ? ` checked="checked"`: ''} />
            <label for="rate_${value}" >
              <img class="slaask-emoji" src="`+emoji+`"  alt="emoji">
            </label>`
        };

        let htmlMessage =`
          <form id="slaask-rating-survey-form-${attachment.id}">
            <section class="slaask-rating" id="slaask-rate">
              ${ratingValues.map(v => radio(v, false)).join('')}
            </section>
            <input type="submit" class="slaask-btn" id="slaask-rating-sutmit-${attachment.id}" value="${data.rating_submit_content}"/>
          </form>`;
        html += htmlMessage;
      }
    });
    return html;
  }

  /**
   * Given the message.attachments, this method will create the needed
   * message interactions based on every Attachment properties (type and action)
   * @param {Message} message
   */
  setAttachmentActions(message) {
    Utils.forEach(message.attachments, attachment => {
      let handler;
      if (attachment.action.type == "postback") {
        handler = () => {
          Ajax.call('/api/postback', {
            'value'            : attachment.action.options.value,
            'conversation_id'  : message.conversation.id,
            'attachment_id'    : attachment.id
          });
        }
        if (~["Attachment::PersistentButton", "Attachment::EphemeralButton"].indexOf(attachment.type)) {
          attachment._interactions = [ message.addInteraction({
            selector: `#asktech-attachment-${attachment.id}`,
            event: 'click',
            handler: event => {
              if (attachment.type == "Attachment::EphemeralButton") {
                message.removeEphemeralAttachments();
              }
              handler();
            }
          }) ];
        }
        if (attachment.type == "Attachment::Input") {
          attachment._interactions = [
            message.addInteraction({
              selector: `#asktech-input-attachment-${attachment.id} .slaask-input`,
              event: 'input',
              handler: event => {
                if (event.target.value.length > 0) Utils.removeClass(event.target, 'asktech-empty');
                else Utils.addClass(event.target, 'asktech-empty');
              }
            }),
            message.addInteraction({
              selector: `#asktech-input-attachment-${attachment.id}`,
              event: 'submit',
              handler: event => {
                event.preventDefault();
                let input = message.querySelector(`#asktech-input-attachment-${attachment.id} .slaask-input`);
                if (input.value.length > 0) {
                  message.removeAttachment(attachment);
                  Ajax.call('/api/postback', {
                    'value'            : input.value,
                    'conversation_id'  : message.conversation.id,
                    'attachment_id'    : attachment.id
                  });
                }
              }
            })
          ];
        }
        if (attachment.type == "Attachment::Rating") {
          message.addInteraction({
            selector: `#slaask-rating-survey-form-${message.attachments[0].id}`,
            event: 'submit',
            handler: e => {
              e.preventDefault();
              var like = message.querySelector(`#slaask-rating-survey-form-${message.attachments[0].id}`).querySelector('[name=slaask-rating-survey-input]:checked');

              Ajax.call('/api/postback', {
                'value'            : like.value,
                'conversation_id'  : message.conversation.id,
                'attachment_id'    : attachment.id
              });
              Utils.removeElement(e.currentTarget);
            }
          });

        }
      }
      else if (attachment.action.type == "link" && attachment.action.options.target == 'frame') {
        attachment._interactions = [ message.addInteraction({
          selector: `#asktech-attachment-${attachment.id}`,
          event: 'click',
          handler: event => {
            if (attachment.type == "Attachment::EphemeralButton") {
              message.removeEphemeralAttachments();
            }
            Views.jumpToViewByName('iframe', attachment.action.options.url);
            event.preventDefault();
            event.stopPropagation();
          }
        }) ];
      }
    });

    if (message.getElement()) {
      this.updateAttachmentsDisplay(message);
    }
  }

  removeAttachmentActions(message) {
    Utils.forEach(message.attachments, attachment => {
      Utils.forEach(attachment._interactions, interaction => {
        message.removeInteraction(interaction);
      })
    });

    if (message.getElement()) {
      this.updateAttachmentsDisplay(message);
    }
  }

  updateAttachmentsDisplay(message) {
    Utils.uniqueTimeout('message-attachments-update-' + message.id, () => {
      this.updateMessage(message, true);
    }, 1);
  }

  newIncomingMessage(m) {
    let conversation = this.get(m.conversation_id);
    if (!conversation) { // Useful for manual message, when the conversation creation is not triggered by the chatbox
      if (!this.app._xeno) {
        this._lockNew();
      }
      conversation = this._newConversation({ id: m.conversation_id });
      this._list[m.conversation_id] = conversation;
    }
    if (conversation && !conversation.isOpened() && conversation.ephemeral) return;
    if (conversation) {
      if (conversation.waiting_for_answer_timeout)
        clearTimeout(conversation.waiting_for_answer_timeout);
      conversation.conversation_answered = true;
      if (conversation.kind == "many" && conversation.getMessageByHash(m.message_hash)) return;
      m.id = m.message_id;
      m.image = m.picture;
      if (m.subtype == 'faq')
        m.parser = Message.PARSER.HTML;
      Utils.feedIfEmpty(m, MS[m.from_type || 'agent']);
      let message = new Message(m);

      if (this._userWasTyping(conversation, message.user_id)) {
        message.conversation = conversation;
        let typingMessage = conversation.user_typings[message.user_id].message;
        message = this._replaceMessageForAnother(typingMessage, message);
        delete conversation.user_typings[message.user_id];
      }
      else {
        conversation.addMessage(message);
      }
      this.app._triggerInternalEvent('recieved_message', { 'message': message.text, 'from': message.name });
      this.app._triggerInternalEvent('received_message', { 'message': message.text, 'from': message.name });
    }
  }

  // Adds the messages the server sent while the websocket was down
  async syncMissedMessages() {
    let conversationIds = [];
    this.forEach(conversation => {
      if (conversation.existsOnServer()) conversationIds.push(conversation.id);
    });
    if (!conversationIds.length) return;

    let response;
    try {
      response = await Ajax.call('/api/sync_messages', { conversation_ids: conversationIds });
    } catch (e) {
      return;
    }
    if (!response || !response.success || !response.messages) return;

    Object.keys(response.messages).forEach(conversationId => {
      let conversation = this.get(conversationId);
      if (!conversation) return;

      response.messages[conversationId].messages.forEach(data => {
        // Visitor messages are sent from here: they may not have their server id yet
        if (data.name == 'me' || conversation.getMessage(data.id)) return;
        conversation.addMessage(new Message(data));
      });
    });
  }

  _userWasTyping(conversation, userId) {
    return conversation.user_typings[userId];
  }

  /**
   * Used to replace typing message by the sent message.
   * The previous message is updated with the data from the new one,
   * without deleting and re-building it.
   *
   * @param  {Message} originalMessage
   * @param  {Message} newMessage
   * @return {Message}                 The final message object
   */
  _replaceMessageForAnother(originalMessage, newMessage) {
    let origId = originalMessage.id;
    let newId = newMessage.id;

    originalMessage.conversation.resetConversationEventsFor(originalMessage);

    const keysBlacklist = ['id', '_attachments', /_eh_/];
    const isBlacklisted = key => {
      let blacklisted = false;
      keysBlacklist.forEach(blacklistedKey => {
        if (blacklistedKey instanceof RegExp) {
          if (key.match(blacklistedKey)) blacklisted = true;
        }
        else {
          if (key == blacklistedKey) blacklisted = true;
        }
      });
      return blacklisted;
    };

    Utils.forEach(originalMessage, (value, key) => {
      if (!isBlacklisted(key)) {
        delete originalMessage[key];
      }
    });

    Utils.forEach(newMessage, (value, key) => {
      if (!isBlacklisted(key)) {
        originalMessage[key] = value;
      }
    });

    originalMessage.id = origId;
    originalMessage.setId(newId);

    originalMessage.conversation.initConversationEventsFor(originalMessage);

    originalMessage.attachments = newMessage.attachments;

    this.updateMessage(originalMessage);

    if (newMessage.type != 'notification') {
      const isAlreadyInBubble = Notifier._messages_in_bubble && Notifier._messages_in_bubble.some(msg => msg === originalMessage);
      if (!isAlreadyInBubble) {
        Notifier.notify(originalMessage);
      }
    }

    return originalMessage;
  }

  submitOnlineForm() {
    let conversation = this.current;

    let inputText = Dom.findById('widget', 'slaask-input').value.trim();
    Dom.updateInputValue('');

    inputText = this.app._askTechParser.parseLinksInMessage(inputText);
    inputText = this.app._askTechParser.Emoji.preEmojify(inputText);

    if(inputText.length > 0) {

      if (conversation.submit_to == 'publish') {

        let message = new Message(MS.visitor, inputText);
        message.status = 1;

        let sendData = {
          'key': this.app._api_key,
          'token': this.app._guest_token,
          'message': message.text,
          'user_group_id': conversation.user_group_id || (Teams.default ? Teams.default.id : null),
          'message_hash': message.hash,
          'trigger': null,
          'current_conversation_id': conversation.id,
          'avatar': message.image
        };

        let currentTrigger = Triggers.getTriggers().filter(trigger => trigger.kind == 'message')[0];

        if (currentTrigger) {
          sendData.trigger = currentTrigger
        }

        conversation.is_typing = false;
        Utils.clearTimeout('guest-typing-' + conversation.id);

        if (this.app._presence_channel) {
          this.app._presence_channel.trigger('client-new_message', sendData)
        }

        if (conversation.id == null && !this.app._xeno) {
          this._lockNew();
        }

        conversation.addToSendQueue(async () => {
          sendData.current_conversation_id = conversation.id;
          let ajaxData = await Ajax.call('/api/publish', sendData);
          this.publishCallback(conversation, ajaxData);
        });

        conversation.addMessage(message);
      }
      else if (conversation.submit_to == 'faq') {
        Faqs.fetchFaqs(conversation, inputText);

        let message = new Message(MS.visitor, inputText);
        message.text = inputText;

        conversation.addMessage(message);
      }
      else {
        Utils.warn('Invalid property value for submit_to');
      }
      this.app._triggerInternalEvent('sent_message', { 'message': inputText, 'from': this.app._guest_id });
    } else {
      if(this.app.getScreenWidth() >= this.app._mobile_threshold) {
        Dom.findById('widget', 'slaask-input').focus();
      }
    }
  }

  publishCallback(conversation, data) {
    // this._presence_channel.trigger('client-availability_callback', data)

    this.app._available = data.available;
    let didCreateConversation = false;

    if(data.error) {
        Triggers.sendTriggerAlert({ name: 'IP banned', kind: 'alert', message: data.message, from: this.app._support_name, cancel_text: 'Ok', embedly_activated: false }, false)
        this.app._destroy();
    } else {

      if (data.message == "delivered") {
        let message = conversation.getMessageByHash(data.message_hash);

        if (data.conversation_id) {
          if (conversation.id == null) {
            this._tempConversationBecomesReal(data.conversation_id);
            didCreateConversation = true;
          }
          this._syncConversationSummary(conversation);
        }

        if (data.message_id)
          message.setId(data.message_id);

        message.status = 2;
        this.updateMessageDisplayedStatus(message);

        if (this.app._email_asking && this.app.isLive())
          this.app._initializeNotAnsweringDelay(conversation);
      }

      // NO TICKETING When widget goes in delayed mode during a conversation, tell the user
      if (!data.available && !(this.app._ticketing_system_enabled || this.app._handle_delayed_by_email)) {
        if (!this._warned_team_unavailable) {
          this._warned_team_unavailable = true;
          this.app._askForEmail(
            conversation,
            'switch_to_offline_xeno',
            'switch_to_offline_xeno_with_email',
            true,
            false);
        }
      }

      // TICKETING When widget goes in delayed mode at the first message, switch to offline mode
      else if (!data.available && (this.app._ticketing_system_enabled || this.app._handle_delayed_by_email) && conversation.id == null) {
        conversation.rejectPromise('switch_to_offline', null);
      }

      // Pending
      else if (data.pending) {
        if (!this._warned_team_unavailable) {
          this._warned_team_unavailable = true;
          this.app._askForEmail(
            conversation,
            'switch_to_pending',
            'switch_to_pending_with_email',
            true,
            false);
        }
      }

      // Online not pending
      else {
        this._warned_team_unavailable = false;
        if (didCreateConversation) {
          let message = new Message(MS.bot, Wording.md('searching_someone_to_answer'));
          conversation.addMessage(message);
        }
      }

      this._trigger('publish-callback', conversation, data);
    }
  }


  // Promises resolves after upload has started
  uploadFile(file, filename) {
    let conversation = this.current;
    return new Promise((resolve, reject) => {

      if (conversation.submit_to == "publish") {
        let reader    = new FileReader();

        reader.onload = (readerEvt) => {
          let dataURL = readerEvt.currentTarget.result;

          let message = new Message(MS.visitor);
          message.text = Wording.uploading + ' :cloud: :\n\n`' + filename + '`';
          conversation.addMessage(message);

          conversation.addToSendQueue(async () => {
            let uploadSentPromise = new Promise((resolve, reject) => {
              conversation.upload_resolves[message.hash] = resolve;
            });
            Utils.log("Ajax call");
            await Ajax.call('/api/upload_file', {
              'key': this.app._api_key,
              'guest_id': this.app._guest_id,
              'file_data': dataURL,
              'filename': filename,
              'user_group_id': conversation.user_group_id,
              'message_hash': message.hash,
              'current_conversation_id': conversation.id
            });
            Utils.log("Ajax done, waiting for completion");
            await uploadSentPromise;
            Utils.log("Completed");
          });

          resolve();
        };

        reader.readAsDataURL(file);
      }
    });
  }

  renderFileUploaded(text, message_hash, conversation_id, new_conversation_id) {
    let conversation = this.get(conversation_id);

    if (conversation.id == null)
      this._tempConversationBecomesReal(new_conversation_id);
    this._syncConversationSummary(conversation);

    let message = conversation.getMessageByHash(message_hash);
    message.text = text;
    this.updateMessage(message);
    if (conversation.upload_resolves[message.hash]) {
      Utils.log("Upload renedered");
      conversation.upload_resolves[message.hash]();
      delete conversation.upload_resolves[message.hash];
    }
  }

  sendAskingforVideo(kind) {
    let conversation = this.current;
    if (conversation.submit_to == "publish") {
      Ajax.call("/api/videochat_request_from_guest", {
        conversation_id: this.current.id,
        kind: kind
      });
    }
  }

  formChatTranscript() {
    let message = new Message(MS.bot);

    message.mandatory_buttons = false;
    message.plain_text = Wording.ask_chattranscript_msg;
    message.text = `
      ${Wording.ask_chattranscript_msg}
      <div>
        <div class="slaask-mandatory-buttons">
          <input id="form-askemail-input" class="slaask-input" name="SendEmail" type="text" size="23" maxlenght="100" placeholder="john@doe.com" />
          <input id="inputSend" class="slaask-btn" type="button" value="${Wording.btn_sendtranscript}" />
        </div>
      </div>
      `;

    message.addInteraction({
      selector: '#inputSend',
      event: 'click',
      removeButtons: true,
      printResponse: e => e.currentTarget.innerHTML,
      handler: e => {
        Ajax.call('/api/chattranscript', {
          'send_email': Dom.findById("widget", "form-askemail-input").value,
          'conv_id': this.current.id,
          'key': this.app._api_key,
          'token': this.app._guest_token
        });

        let messageRetour = new Message(MS.bot, Wording.transcript_sent_feedback);
        this.current.addMessage(messageRetour);
      }
    });

    this.current.addMessage(message);
  }

  _addMessage(message, silent = false) {
    let conversation = this.get(message.conv_id);

    if (MessageException.process(message)) return;
    this.initializeAttachments(message);

    if (Views.current.name == 'conversation' && this.isDisplayed(conversation)) {
      this._renderMessage(message);
      this.keepScrollOnBottom(conversation);
    }

    Utils.uniqueTimeout('conversationInputDisplay', () => {
      this._syncInputDisplay(conversation);
    }, 16);

    if (message.type != "notification") {
      Utils.uniqueTimeout('conversationSummary' + conversation.id, () => {
        this._syncConversationSummary(conversation);
      }, 16);

      if (!silent) {
        const isEmptyWithOnlyButtons = !message.text.trim() && message._attachments && message._attachments.length > 0;
        if (!isEmptyWithOnlyButtons) {
          Notifier.notify(message);
        }
      }
    }

  }

  removeButtonsFromMessage(message) {
    message.interactions.forEach(interaction => {
      interaction.removeButtons = false;
    });
    message.mandatory_buttons = false;
    this.removeElementsFromMessage(message, '.slaask-btn, .slaask-mandatory-buttons, .button');
  }

  removeMandatoryButtons(conversation) {
    for (let i = this.messages.length - 1 ; i >= 0 ; i--) {
      if (this.messages[i].mandatory_buttons) {
        this.removeButtonsFromMessage(this.messages[i]);
      }
      else if (this.messages[i].fromVisitor()) return;
    }
  }

  removeElementsFromMessage(message, selector) {
    let temp = document.createElement('div');
    temp.innerHTML = message.text;
    temp.querySelectorAll(selector).forEach(x => Utils.removeElement(x));
    message.text = temp.innerHTML;
    this.updateMessage(message);
  }

  _removeMessage(message) {
    this._eraseMessage(message);
    this._syncConversationSummary(message.conversation);
    this._syncInputDisplay(message.conversation);
  }

  _eraseMessage(message) {
    let conversation = message.conversation;
    if (Views.current.name == 'conversation' && this.current.id == conversation.id) {
      let messageEl = message.getElement();
      if (messageEl) {
        let nextMessage = messageEl.nextElementSibling;
        Utils.removeElement(messageEl);
        if (nextMessage) {
          let nextMessageId = Utils.deepGet(nextMessage, ["dataset", "id"]);
          this._syncSenderChanged(conversation.getMessage(nextMessageId));
        }
      }
    }
  }

  _reorderMessage(message) {
    this._eraseMessage(message);
    this._renderMessage(message, { checkOrder: true });
    this._syncConversationSummary(message.conversation);
    this._syncInputDisplay(message.conversation);
    requestAnimationFrame(() => { this.keepScrollOnBottom(message.conversation); });
  }

  removeMessageFromId(messageId) {
    let message = Message.get(messageId);
    if (message) {
      let conversation = this.get(message.conv_id);
      if (conversation) conversation.removeMessage(message);
      else Message.dereference(messageId);
    }
    else Utils.warn(`Message ${messageId} not found`);
  }

  editMessageFromId(messageId, text, translated = null) {
    let message = Message.get(messageId);
    if (message) {
      message.text = text;
      message.translated = translated;
      this.updateMessage(message);
    }
  }

  moderateLastGuestMessage() {
    const guestMessages = this.current.messages.filter(m => m.fromVisitor());
    
    if (guestMessages.length > 0) {
      const lastGuestMessage = Utils.last(guestMessages);

      lastGuestMessage.text = '{{moderated}}'

      this.updateMessage(lastGuestMessage);
    }
  }

  addTextToMessageFromId(messageId, chunk) {
    let message = Message.get(messageId);
    if (message) {
      message.text = message.text + chunk
      this.updateMessage(message);

      let conversation = this.get(message.conv_id);

      if (Views.current.name == 'conversation' && this.isDisplayed(conversation)) {
        let messageEl = message.getElement();
        if (messageEl) {
          messageEl.setAttribute('aria-busy', 'true');
          messageEl.setAttribute('aria-live', 'off');
        }
        this.keepScrollOnBottom(conversation);
      }
    }
  }

  updateMessage(message, previewAlreadyRendered = false) {
    Utils.emptyCache('message-' + message.id);
    let conversation = this.get(message.conv_id);
    if (conversation) {
      if (Views.current.name == 'conversation' && this.current.id == conversation.id) {
        let messageEl = message.getElement();
        if (messageEl) {
          // Clear any existing timeout
          if (message._stabilityTimeout) {
            clearTimeout(message._stabilityTimeout);
          }
          
          // Set a new timeout to check if the message is stable
          message._stabilityTimeout = setTimeout(() => {
            messageEl.setAttribute('aria-busy', 'false');
            messageEl.setAttribute('aria-live', 'polite');
            
            // Force NVDA to read the message using aria-label
            let ctextWrap = messageEl.querySelector('.ctext-wrap');
            if (ctextWrap) {
              ctextWrap.setAttribute('aria-label', message.text);
            }
            
            delete message._stabilityTimeout;
          }, 500);
        }
        this._renderMessage(message, { replaceExistingContent: true, previewAlreadyRendered: previewAlreadyRendered });
      }
      
      Notifier.updateBubble(message);
      
      this._syncConversationSummary(conversation);
      this._syncInputDisplay(conversation);
    }
    else Message.dereference(messageId);
  }

  _renderMessage(messages, options = null) {
    if (!Array.isArray(messages)) messages = [ messages ];
    if (!messages.length) return;
    if (!options) {
      options = {
        checkOrder: false,
        replaceExistingContent: false
      };
    }

    // Prevent instant scroll when current scroll is past max scroll
    const scrollable = Views.getByName('conversation').getScrollableElement();
    const maxScroll = scrollable.scrollHeight - scrollable.offsetHeight;
    if (scrollable.scrollTop > maxScroll) {
      scrollable.scrollTop = maxScroll;
    }

    let conversation = messages[0].conversation;

    if (!Dom.get('widget').isReady() || !this.isDisplayed(conversation)) return;

    let htmlTotal = "";
    let lastIndex = messages.length - 1;
    messages.forEach((message, index) => {
      // From
      let fromName = message.name.split('-#');
      fromName = fromName.length == 1
                  ? fromName[0]
                  : fromName[0] + '<span class="description"> - #' + fromName[1] + '</span>';

      // Text
      let displayable = this.getMessageContent(message);

      // Classes
      let ctextWrapClass = '';
      let liClass        = '';
      let tmp            = document.createElement("DIV");
      tmp.innerHTML      = displayable;

      const preview = Previewer.buildPreview(displayable);
      if (preview.enabled) {
        ctextWrapClass += preview.cssClass;
        displayable = preview.displayableContent;
      }

      if (message.answer_type == 'ai') {
        ctextWrapClass += ' no-transition';
      }

      if (this.app._askTechParser.Emoji.isOnlyEmoji(displayable)
          || (!preview.enabled && this.app._askTechParser.isOnlyImg(displayable)))
        ctextWrapClass += ' ctext-wrap-emoji';
      if (message.fromVisitor())
        liClass += " odd";

      if (message.custom_class)
        liClass += " " + message.custom_class;

      if (liClass[0] == ' ') liClass = liClass.substr(1);

      if (displayable == '' && message._attachments.length == 0) {
        liClass += " slaask-message-empty";
      }

      // Status
      if (!options.replaceExistingContent) {
        let messagesStatus = Dom.findAll('widget', '#conversation-list .conversation-data');
        if (messagesStatus.length > 0) {
          let lastMessageStatus = Utils.last(messagesStatus);
          requestAnimationFrame(() => {
            Utils.removeElement(lastMessageStatus);
          });
        }
      }

      // HTML
      let avatarHtml =
        message.fromVisitor() ? ``
                              : `<div class="chat-avatar">
                                  <img onerror="onerror=null;src=\'${this.app._support_img}\';" src="${message.image}" alt="" aria-hidden="true">
                                </div>`;

      let fromNameHtml =
        message.fromVisitor() ? ``
                              : `<div class="message-from-name">
                                  <i>${fromName}</i>${message.formatedFromDescription()}
                                </div>`;
      let bodyHtml =
        message.fromVisitor() ? displayable
                              : `<div class="slaask-message-body" style="color:${this.app._chat_text_color}!important">
                                  ${displayable}
                                </div>
                                ${this.app._renderActionLink(message.action_link)}`;

      let attachmentsHtml = this.getAttachmentHtml(message);

      //
      // Uncomment to add time to messages
      //
      // let statusHtml =
      //   index == lastIndex && message.type != 'typing' ?
      //     message.fromVisitor() && message.formatedStatus() != '' ? `<div class="conversation-data">
      //                               <span class="conversation-data-content">
      //                                 ${message.formatedStatus()}
      //                               </span>
      //                               <span class="conversation-time-content">
      //                                 - ${this.app._createTimeAgo(null, message.created_at).innerHTML.replace('&nbsp; ', '')}
      //                               </span>
      //                             </div>`
      //                           : `<div class="conversation-data">
      //                               <span class="conversation-time-content">
      //                                 ${this.app._createTimeAgo(null, message.created_at).innerHTML.replace('&nbsp; ', '')}
      //                               </span>
      //                             </div>`
      //                     :
      //                       ``;

      let statusHtml =
        index == lastIndex &&
        message.fromVisitor() ? `<div class="conversation-data">
                                  <span class="conversation-data-content">
                                    ${message.formatedStatus()}
                                  </span>
                                </div>`
                              : ``;

      // Check if message is complete (no placeholders)
      const isComplete = !message.text.includes('{{generating}}') && !message.text.includes('{{searching}}');

      let toolCallsHtml = '';
      if (message.tool_calls && message.tool_calls.length > 0) {
        toolCallsHtml = `<div class="tool-calls">
          ${message.tool_calls.map((toolCall) => {
            return `<div class="tool-call">
              <p id="show-sources-${message.id}" class="tool-call-show-sources ${message.show_sources ? 'slaask-hidden' : ''}">
                Voir les sources
                ${Svg.chevronDown('#888da8', '20px')}
              </p>
              <p id="hide-sources-${message.id}" class="tool-call-hide-sources ${message.show_sources ? '' : 'slaask-hidden'}">
                Masquer les sources
                ${Svg.chevronUp('#888da8', '20px')}
              </p>
              <div class="tool-call-results ${message.show_sources ? '' : 'slaask-hidden'}">${toolCall.content.content.map((article) => {
                return `<p class="tool-call-result">${article.title}</p>`
              }).join('')}
              </div>
            </div>`
          }).join('')}
        </div>`;
      }

      let html = `
        <li id="slaask-message-${message.id}" class="${liClass}" data-id="${message.id}" tabindex="0" role="article" aria-label="${Wording.message_from.replace('%{name}', message.name)}" aria-busy="${!isComplete}" aria-live="${isComplete ? 'polite' : 'off'}">
          ${avatarHtml}
          <div class="conversation-text">
            <div class="ctext-wrap ${ctextWrapClass}">
              ${fromNameHtml}
              ${bodyHtml}
              ${toolCallsHtml}
            </div>
            ${attachmentsHtml}
            ${statusHtml}
          </div>
        </li>`;


      // Insert in DOM
      const textChangedSinceLastRender = message.textChangedSinceLastRender();
      const existingElement = message.getElement();
      if (existingElement) {
        let ctextWrap         = message.querySelector('.ctext-wrap');
        let previousHeight    = ctextWrap.offsetHeight;
        let scrollFromBottom  = scrollable.scrollHeight - scrollable.scrollTop - scrollable.offsetHeight;

        let temp = document.createElement('div');
        temp.innerHTML = html;
        existingElement.innerHTML = temp.firstElementChild.innerHTML;
        if (!textChangedSinceLastRender) {
          const newCtextWrap = message.querySelector('.ctext-wrap');
          newCtextWrap.parentNode.replaceChild(ctextWrap, newCtextWrap);
        }

        if (!Utils.isIe9 && !document.hidden) {
          let newCtextWrap = message.querySelector('.ctext-wrap');
          let newHeight = newCtextWrap.offsetHeight;
          newCtextWrap.style.height = previousHeight + "px";
          scrollable.scrollTop = scrollable.scrollHeight - scrollFromBottom - scrollable.offsetHeight;
          requestAnimationFrame(() => {
            newCtextWrap.style.height = newHeight + "px";
          });
          this._setTimeout(() => {
            newCtextWrap.style.height = "";
          }, 1000);
          if (!options.previewAlreadyRendered) {
            Views.getByName('conversation').tempBlockScroll(400);
          }
        }
        if (options.checkOrder) Utils.warn("checkOrder option was ignored since the message was already present.");
      }
      else if (options.checkOrder) {
        this._eraseMessage(message);
        let index = conversation.messages.indexOf(message);
        let nextMessage = conversation.messages[index + 1];
        if (nextMessage && nextMessage.getElement()) {
          nextMessage.getElement().insertAdjacentHTML('beforebegin', html);
          this._syncSenderChanged(nextMessage);
        }
        else {
          htmlTotal += html;
        }
      }
      else {
        htmlTotal += html;
      }

      preview.setAttached(true);
    });

    Dom.findById('widget', 'conversation-list').insertAdjacentHTML('beforeend', htmlTotal);

    messages.forEach(message => {
      // Check if sender has changed
      this._syncSenderChanged(message);
      this._decorateAiCopyLinks(message);

      // Interactions
      this._applyMessageInteractions(message);
    });

    // Focus
    let lastMessage = Utils.last(messages);
    let focusElement = lastMessage.querySelector(lastMessage.focus);
    if (focusElement) {
      this._setTimeout(() => {
        focusElement.focus();
      }, 700);
    }
  }

  updateMessageDisplayedStatus(message) {
    let statusEl = message.querySelector('.conversation-data-content');
    if (statusEl) {
      Utils.addClass(statusEl, 'updating')
      this._setTimeout(() => {
      statusEl.innerHTML = message.formatedStatus();
        Utils.removeClass(statusEl, 'updating')
      }, 300)
    }
  }

  _syncSenderChanged(message) {
    if (message) {
      let conversation = this.get(message.conv_id);
      let messageEl = message.getElement();
      if (messageEl) {
        let previousMessageEl = messageEl.previousElementSibling;
        if (previousMessageEl) {
          let previousMessage = conversation.getMessage(Utils.dataSet(previousMessageEl, 'id'));
          if (previousMessage) {
            if ((previousMessage.user_id && message.user_id)
                ? previousMessage.user_id != message.user_id
                : previousMessage.name != message.name) Utils.addClass(previousMessageEl, 'slaask-message-from-end');
            else Utils.removeClass(previousMessageEl, 'slaask-message-from-end');
          }
        }
      }
    }
  }

  _decorateAiCopyLinks(messageOrElement) {
    let messageEl = messageOrElement;
    if (messageOrElement && messageOrElement.getElement) {
      if (messageOrElement.answer_type != 'ai') return;
      messageEl = messageOrElement.getElement();
    }
    if (!messageEl) return;
    if (!messageOrElement.getElement) {
      const message = Message.get(String(messageEl.id || '').replace('slaask-message-', ''));
      if (!message || message.answer_type != 'ai') return;
    }

    const body = messageEl.querySelector('.slaask-message-body');
    if (!body) return;
    this._bindCopyLinkClicks();

    const seen = {};
    body.querySelectorAll('a[href]').forEach((link) => {
      if (link.classList.contains('slaask-btn') || link.classList.contains('asktech-btn') || link.classList.contains('button')) return;
      const preview = Utils.closest(link, '.slaask-link-preview');
      if (preview && preview !== link) return;
      const isPreview = link.classList.contains('slaask-link-preview');
      if (!isPreview && link.querySelector('img')) return;
      if (Utils.closest(link, '.slaask-copy-link-wrap')) return;
      if (link.nextElementSibling && Utils.matches(link.nextElementSibling, '.slaask-copy-link')) return;

      const value = this._copyableTarget(link);
      if (!value) return;
      if (isPreview && seen[value]) return;
      seen[value] = true;
      this._insertCopyButton(link, value, isPreview);
    });
    this._decorateBareFilePaths(body);
  }

  _copyableTarget(link) {
    const raw = (link.getAttribute('href') || '').trim();
    if (!raw || /^(javascript:|#)/i.test(raw)) return null;
    if (/^https?:\/\//i.test(raw)) return link.href || raw;
    if (/^file:/i.test(raw) || this._isFilePath(raw)) return raw;
    return null;
  }

  _isFilePath(value) {
    if (/^\\\\[^\s<>"']+\\[^\s<>"']+/.test(value)) return true;
    if (/^\/\/[^\s<>"']+\/[^\s<>"']+/.test(value)) return true;
    if (/^\\[^\s<>"']+\\[^\s<>"']+/.test(value) && value.indexOf('.') !== -1) return true;
    return /^\/[^\s<>"']+\/[^\s<>"']+/.test(value) && value.indexOf('.') !== -1;
  }

  _decorateBareFilePaths(body) {
    const pattern = /file:\/\/[^\s<>"']+|\\\\[^\s<>"'\\]+(?:\\[^\s<>"'\\]+)+|\\[^\s<>"'\\]+(?:\\[^\s<>"'\\]+)+|\/\/[^\s<>"'/]+(?:\/[^\s<>"'/]+)+|\/[^\s<>"'/]+(?:\/[^\s<>"'/]+)+/gi;
    const nodes = [];
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      const parent = node.parentElement;
      if (!parent || Utils.closest(parent, 'a, button, .slaask-copy-path, .slaask-copy-link, .slaask-link-preview')) continue;
      pattern.lastIndex = 0;
      if (pattern.test(node.nodeValue)) nodes.push(node);
    }
    nodes.forEach((textNode) => {
      const text = textNode.nodeValue;
      const frag = document.createDocumentFragment();
      let last = 0;
      let match;
      pattern.lastIndex = 0;
      while ((match = pattern.exec(text))) {
        const value = match[0].replace(/[.,;:)\]}>]+$/, '');
        const before = match.index > 0 ? text.charAt(match.index - 1) : '';
        if (!/^file:/i.test(value) && /[:\w]/.test(before)) continue;
        if (!/^file:/i.test(value) && !this._isFilePath(value)) continue;
        if (match.index < last) continue;
        frag.appendChild(document.createTextNode(text.slice(last, match.index)));
        const span = document.createElement('span');
        span.className = 'slaask-copy-path';
        span.textContent = value;
        frag.appendChild(span);
        this._insertCopyButton(span, value, false);
        if (match[0].length > value.length) frag.appendChild(document.createTextNode(match[0].slice(value.length)));
        last = match.index + match[0].length;
      }
      if (!last) return;
      frag.appendChild(document.createTextNode(text.slice(last)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  _insertCopyButton(afterEl, value, card) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'slaask-copy-link';
    button.setAttribute('data-href', value);
    button.setAttribute('aria-label', Wording.copy_link);
    button.innerHTML = Svg.copy('currentColor', '13px');
    if (card) {
      button.classList.add('slaask-copy-link-card');
      if (afterEl.parentElement) afterEl.parentElement.classList.add('slaask-copy-link-anchor');
      afterEl.insertAdjacentElement('afterend', button);
      return;
    }
    const wrap = document.createElement('span');
    wrap.className = 'slaask-copy-link-wrap';
    afterEl.parentNode.insertBefore(wrap, afterEl);
    wrap.appendChild(afterEl);
    wrap.appendChild(button);
  }

  _bindCopyLinkClicks() {
    const list = Dom.findById('widget', 'conversation-list');
    if (!list || list.getAttribute('data-copy-links') === '1') return;
    list.setAttribute('data-copy-links', '1');
    list.addEventListener('click', (event) => {
      const button = Utils.closest(event.target, '.slaask-copy-link');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const href = button.getAttribute('data-href');
      if (!href) return;
      this._copyLink(button, href);
    });
  }

  _copyLink(button, href) {
    if (this._copyTextNow(button, href)) {
      this._showCopied(button);
      return;
    }
    const view = button.ownerDocument.defaultView;
    if (view && view.navigator.clipboard && view.navigator.clipboard.writeText) {
      view.navigator.clipboard.writeText(href).then(() => this._showCopied(button)).catch(() => {});
    }
  }

  _copyTextNow(button, href) {
    const doc = button.ownerDocument;
    const area = doc.createElement('textarea');
    area.value = href;
    area.setAttribute('aria-hidden', 'true');
    area.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;';
    doc.body.appendChild(area);
    area.focus();
    area.select();
    area.setSelectionRange(0, area.value.length);
    let ok = false;
    try { ok = doc.execCommand('copy'); } catch (e) { ok = false; }
    doc.body.removeChild(area);
    return ok;
  }

  _showCopied(button) {
    button.classList.add('is-copied');
    button.innerHTML = Svg.copyCheck('currentColor', '13px');
    button.setAttribute('aria-label', Wording.link_copied);
    if (button._copyTimer) clearTimeout(button._copyTimer);
    button._copyTimer = setTimeout(() => {
      if (!button.parentNode) return;
      button.classList.remove('is-copied');
      button.innerHTML = Svg.copy('currentColor', '13px');
      button.setAttribute('aria-label', Wording.copy_link);
      button._copyTimer = null;
    }, 1400);
  }

  _applyMessageInteractions(message) {
    let interactions = message.interactions;
    let messageEl = message.getElement();
    if (interactions && messageEl) {
      interactions.forEach(interaction => {
        let elements = messageEl.querySelectorAll(interaction.selector);
        // if (interaction.removeButtons) {
        //   let conversation = this.get(message.conv_id);
        //   conversation.once('new_visitor_message', () => { this.removeButtonsFromMessage(message) });
        // }
        elements.forEach(element => element.addEventListener(interaction.event, e => {
          if (interaction.printResponse) {
            let responseText = interaction.printResponse(e);
            if (responseText)
              this.get(message.conv_id).addMessage(new Message(MS.visitor, responseText.trim()));
          }
          let handlerRes = interaction.handler(e);
          if (interaction.removeButtons && handlerRes !== false)
            this.removeButtonsFromMessage(message);
          return handlerRes;
        }));
      });
    }
  }

  _syncInputDisplay() {
    if (Views.current.name == 'conversation') {
      Views.syncInputDisplay();
      this._syncInputPlaceholder();
    }
  }

  _syncInputPlaceholder() {
    const input = Dom.findById('widget', 'slaask-input');
    if (!input || Views.current.name !== 'conversation' || !this.current) return;
    const placeholder = this.current.ephemeral
      ? Wording.new_ephemeral_conversation_text
      : (this.app.isLive() ? Wording.online_input_content : Wording.bot_input_text);
    input.placeholder = Array.isArray(placeholder) ? placeholder[0] : placeholder;
  }

  shouldDisplayInput() {
    return this.current.shouldDisplayInput() && !this.waitingForBotTree(this.current);
  }

  _syncFileSharingDisplay() {
    const fileSharingEnabled =  this.current.submit_to == 'publish'
                                && this.current.existsOnServer();
    Dom.toggleFileSharingDisplay(fileSharingEnabled);
    Dom.toggleConversationMenuFeatures({
      video: !this.current.bot_tree_running,
      screensharing: !this.current.bot_tree_running,
      transcript: this.app._chattranscript_enabled && !this.current.ephemeral
    });
    Dom._syncHeaderEphemeralButton();
  }

  deleteConversation(m) {
    let conversation = this.get(m.conversation_id);
    if (conversation) {
      if (conversation == this.current) {
        if (Views.getByName('conversations').soapy) {
          Views.jumpToViewByName('conversation', null);
        }
        else {
          Views.jumpToViewByName('conversations');
        }
      }
      delete this._list[conversation.id];
      this._removeConversationSummary(conversation);
      this._syncSummaryListViewDisplay();
      this._initTempConversation();
      conversation.destroy();
      Utils.emptyCache('conversations');
    }
  }

  /* TEMP CONVERSATION */

  _initTempConversation() {
    if (!this._temp_conversation && this.canOpenNew()) {
      this._temp_conversation = this._newConversation();
    }
  }

  _tempConversationBecomesReal(conversationId) {
    this._temp_conversation.setId(conversationId);
    this._list[conversationId] = this._temp_conversation;
    this._temp_conversation = null;
    Utils.emptyCache('conversations');

    let summaries = Dom.findAll('widget', '.slaask-widget-convpage-conversation');
    for (let i = 0 ; i < summaries.length ; i++) {
      if (Utils.dataSet(summaries[i], 'convid') == "null") {
        Utils.dataSet(summaries[i], 'convid', conversationId);
        summaries[i].id = summaries[i].id.replace(/null$/, conversationId);
      }
    }

    this.app._subscribeToChannel();

    this._syncSummaryListViewDisplay();

    if (!this.canOpenNew()) {
      this._lockNew();
    }

    let view = Views.getByName('conversation');
    if (!view.getState()) view.setState(conversationId);

    this._syncFileSharingDisplay();
    this._syncInputDisplay();
  }

  /* SUMMARIES */

  subscribeSummaryList(container, idPrefix, max, needsVisitorMessage = false, shouldBeOpen = false) {
    this._summaryDisplays.push({
      container: container, idPrefix: idPrefix, max: max, needsVisitorMessage: needsVisitorMessage, shouldBeOpen: shouldBeOpen
    });
  }

  // inject convs en cours function

  _syncConversationSummary(conversation) {
    Views.when('ready').then(() => {
      this._refreshClosedAsNormalLayout(conversation);
      this._applyConversationSummary(conversation);
    });
  }

  _onlyClosedConversations() {
    let hasActive = false;
    const consider = conversation => {
      if (!conversation || hasActive) return;
      if (!conversation.getLastMessage(true)) return;
      if (!conversation.isOpen() && conversation.ephemeral) return;
      if (conversation.isOpen() || conversation.isSnoozed()) hasActive = true;
    };
    this.forEach(consider);
    if (this._temp_conversation && this._shouldDisplayTempInList()) consider(this._temp_conversation);
    return !hasActive;
  }

  _refreshClosedAsNormalLayout(except) {
    const onlyClosed = this._onlyClosedConversations();
    if (this._onlyClosedLayout === onlyClosed) return;
    this._onlyClosedLayout = onlyClosed;
    this.forEach(conv => {
      if (conv !== except) this._applyConversationSummary(conv);
    });
    if (this._temp_conversation && this._temp_conversation !== except && this._shouldDisplayTempInList()) {
      this._applyConversationSummary(this._temp_conversation);
    }
  }

  _applyConversationSummary(conversation) {
    if (conversation != this._temp_conversation || this._shouldDisplayTempInList()) {
      for (let id = 0 ; id < this._summaryDisplays.length ; id++) {
        let display = this._summaryDisplays[id];

        if (display.needsVisitorMessage && !conversation.hasVisitorMessage()) continue;
        if (display.shouldBeOpen && !conversation.isOpen()) continue;
        if (!display.shouldBeOpen && !conversation.isOpen() && conversation.ephemeral) {
          let convEl = Dom.findById('widget', display.idPrefix + conversation.id);
          if (convEl) Utils.removeElement(convEl);
          continue;
        }

        let containerEl = Dom.findById('widget', display.container);
        if (!display.shouldBeOpen) {
          if (conversation.isOpen() || this._onlyClosedLayout) {
            containerEl = containerEl.querySelector('.open')
          } else {
            containerEl = containerEl.querySelector('.closed')
          }
        }

        let convEl = Dom.findById('widget', display.idPrefix + conversation.id);
        if (convEl) {
          let newSummary = this._createConversationSummary(conversation);
          if (newSummary) {
            convEl.innerHTML = newSummary.innerHTML;
            if (newSummary.getAttribute('aria-label')) {
              convEl.setAttribute('aria-label', newSummary.getAttribute('aria-label'));
            }
            this._appendSummary(conversation, containerEl, convEl);
          } else {
            Utils.removeElement(convEl);
          }
        } else {
          if (containerEl.children.length >= display.max) {
            Utils.removeElement(containerEl.children[containerEl.children.length - 1]);
          }
          this._syncSummaryListViewDisplay();
          this._trigger('adding-summary', conversation, containerEl);
          this._addConversationSummary(conversation, containerEl, display.idPrefix);
        }
      }
      this._syncClosedSectionChevron();
    }
  }

  _syncClosedSectionChevron() {
    const view = Views.getByName('conversations')._element;
    if (!view) return;
    const closedEl = view.querySelector('.closed');
    const chevronEl = view.querySelector('.collapsing-chevron');
    if (!closedEl || !chevronEl) return;
    chevronEl.classList.toggle('visible', closedEl.children.length > 0);
  }

  _removeConversationSummary(conversation) {
    Views.when('ready').then(() => {
      for (let id = 0 ; id < this._summaryDisplays.length ; id++) {
        let display = this._summaryDisplays[id];
        let convEl = Dom.findById('widget', display.idPrefix + conversation.id);
        if (convEl) Utils.removeElement(convEl);
      }
      this._refreshClosedAsNormalLayout(conversation);
      this._syncClosedSectionChevron();
    });
  }

  _addConversationSummary(conversation, container, idPrefix) {
    const convEl = this._createConversationSummary(conversation);
    if (convEl) {
      convEl.id = idPrefix + conversation.id;
      this._appendSummary(conversation, container, convEl);
    }
  }

  /**
   * Finds the right place to insert the summary into the list
   * among other summaries
   * @param {Conversation} conversation
   * @param {string | HTMLElement} container
   * @param {HTMLElement} convEl
   */
  _appendSummary(conversation, container, convEl) {
    const lastMessage = conversation.getLastMessage(true);
    if (!lastMessage) return;
    
    const lastMessageAtTs = lastMessage.created_at_ts;

    const containerEl = typeof container == 'string' ? Dom.findById('widget', container) : container;
    let insertBeforeEl = null;
    
    if (convEl.parentElement) convEl.parentElement.removeChild(convEl);
    
    try {
      for (let i = 0; i < containerEl.children.length; i++) {
        const otherConvEl = containerEl.children[i];
        const otherConvId = otherConvEl.getAttribute('data-convid');
        if (otherConvId == conversation.id) continue;
        
        const otherConv = this.get(otherConvId);
        if (!otherConv) {
          Utils.warn("Can't find conversation for summary with ID " + otherConvId);
          continue;
        }
        
        const otherLastMessage = otherConv.getLastMessage(true);
        if (!otherLastMessage) continue;
        
        const otherLastMessageAt = otherLastMessage.created_at_ts;

        if (lastMessageAtTs > otherLastMessageAt) {
          insertBeforeEl = otherConvEl;
          break;
        }
      }
    } catch(e) {
      Utils.warn(e);
    }
    
    if (insertBeforeEl) {
      insertBeforeEl.insertAdjacentElement('beforebegin', convEl);
    } else {
      containerEl.insertAdjacentElement('beforeend', convEl);
    }
  }

  _shouldDisplayTempInList() {
    return !this._new_locked && (this.temp_conversation.hasVisitorMessage() || !this.hasLive());
  }

  _createConversationSummary(conversation) {
    let lastMessage = conversation.getLastMessage(true);

    if (!lastMessage) return;

    let displayedName, lastMessageText, image, notif;
    displayedName = lastMessageText = image = notif = '';

    let timeAgoSpan = this.app._createTimeAgo(null, lastMessage.created_at_ts);

    let convEl                = document.createElement('div');
    convEl.className          = "slaask-widget-convpage-conversation";
    Utils.dataSet(convEl, 'user_group', conversation.user_group_id);
    Utils.dataSet(convEl, 'convid', conversation.id);
    Utils.dataSet(convEl, 'triggerid', lastMessage.trigger_id);
    convEl.setAttribute('tabindex', '0');
    convEl.setAttribute('role', 'button');

    if (conversation.isOpen() || conversation.isSnoozed()) {
      displayedName = lastMessage.fromGuest() ? Wording.you : lastMessage.name;
      lastMessageText = this.getMessageContent(lastMessage, true);
      image = `<img src="${lastMessage.fromGuest() ? this.app._message_displayed_image : lastMessage.image}" aria-hidden="true" alt="" />`;
      if (conversation.unread_messages) {
        notif = `<div class="slaask-widget-convpage-unread" data-id="${conversation.id}" data-unread="${Math.min(conversation.unread_messages, 10)}"></div>`;
      }

      if (lastMessage.text == '' && lastMessage.attachments.length > 0) {
        lastMessageText = lastMessage.attachments.map(attachment => attachment.options.text).join('. ');
      }
    }

    /*else if () {
      displayedName = Wording.snoozed_conversation_short_text;
      lastMessageText = this.getMessageContent(lastMessage, true);
      image = `<img src="${lastMessage.image}" />`;
    }
    */
    else {
      image = Svg.check();
      displayedName = Wording.closed_conversation_short_text;
      const questionMessage = conversation.lookForQuestion();
      lastMessageText = questionMessage ? this.getMessageContent(questionMessage, true) : '';
    }

    const analysisSummary = conversation.analysis_summary && String(conversation.analysis_summary).trim();
    const ariaMessage = analysisSummary || lastMessageText;
    if (analysisSummary) {
      lastMessageText = this._escapeHtml(analysisSummary.replace(/\s+/g, ' '));
    }

    convEl.setAttribute('aria-label', Wording.open_conversation.replace('%{name}', displayedName).replace('%{message}', ariaMessage));

    convEl.innerHTML = `
      <div class="slaask-widget-convpage-conversation-image">
        ${image}
      </div>
      <div class="slaask-widget-convpage-conversation-content">
        <div class="slaask-widget-title-table">
          <div class="slaask-widget-title-cell">
            <span>
              ${displayedName}
            </span>
          </div>
          <div class="slaask-widget-title-info-cell">
            ${timeAgoSpan.outerHTML}
          </div>
        </div>
        <div class="slaask-widget-title-table">
          <div class="slaask-widget-title-cell">
            <span>
              ${lastMessageText}
            </span>
          </div>
          <div class="slaask-widget-title-info-cell">
            ${notif}
          </div>
        </div>
      </div>`;

    convEl.addEventListener("click", (e) => {
      Views.jumpToViewByName('conversation', conversation.id);
    });

    return convEl;
  }

  applyAnalysisSummary(conversation, summary) {
    if (!conversation || !summary || !String(summary).trim()) return;
    conversation.analysis_summary = summary;
    this._syncConversationSummary(conversation);
  }

  _escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  _syncSummaryListViewDisplay() {
    if (Object.keys(this._list).length == 0)
      this._disableConversationsListView();
    else
      this._enabledConversationsListView();
  }

  _disableConversationsListView() {
    if (Homepage.skipsToConversationsOnly()) {
      this._user_committed_to_new_conversation = false;
    }

    Views.getByName('conversations').soapy = true;
    if (Views.current.name == 'conversations') Views.jumpToViewByName('conversation', null);
  }

  _enabledConversationsListView() {
    Views.getByName('conversations').soapy = false;
  }


  _userTyping(conversation, typingData) {
    let message        = new Message(MS.typing);
    message.image      = typingData.image;
    message.name       = typingData.name;
    message.user_id    = typingData.user_id;
    typingData.message = message;
    conversation.addMessage(message, true);
  }

  _userStoppedTyping(conversation, typingData) {
    if (!typingData.at_message_sent && typingData.message) {
      conversation.removeMessage(typingData.message);
      typingData.message = null;
    }
  }

  _displayConversation(conversation) {
    this._currently_displayed = conversation;

    this._renderMessage(conversation.messages);

    Views.getByName('conversation').scrollToBottom();
  }

  /**
   * isDisplayed
   * Conversations.current returns the conversation that is displayed
   * OR that is going to be displayed.
   * This function returns true if and only if the conversation is currently displayed
   * in DOM.
   * @param  {Conversation}  conversation
   * @return {Boolean}
   */
  isDisplayed(conversation) {
    return this._currently_displayed && this._currently_displayed.id == conversation.id;
  }


  /* UTILS */

  _conversationOrId(conversationOrId) {
    let conversation;
    if (conversationOrId.constructor != Conversation) {
      let id = conversationOrId;
      conversation = this.get(id);
      if (!conversation) {
        throw "Failed to get conversation " + id;
      }
    }
    else conversation = conversationOrId;
    return conversation;
  }

  get count() {
    return Object.keys(this._list).length;
  }

  get last() {
    return Utils.cacheSync('conversations', 'last', () => {
      let orderedConversations = this.toArray();
      return orderedConversations.length > 0
              ? orderedConversations[orderedConversations.length - 1]
              : null;
    });
  }

  get last_private() {
    let keys = Object.keys(this._list).map(id => parseInt(id)).sort((a, b) => {
      return b - a;
    });
    for (let i = 0 ; i < keys.length ; i++) {
      if (this._list[keys[i]].kind == "one")
        return this._list[keys[i]];
    }
  }

  get current() {
    return this.get(Views.getByName('conversation').getState()) || this.temp_conversation || this.last;
  }

  get temp_conversation() {
    if (!this._temp_conversation) this._initTempConversation();
    return this._temp_conversation;
  }

  get xeno() {
    return this.app._xeno;
  }

  get warned_team_unavailable() {
    return this._warned_team_unavailable;
  }

  getMessagesLists() {
    let res = [];
    let conversationsArray = this.toArray(true);
    for (let id = 0 ; id < conversationsArray.length ; id++) {
      res.push(conversationsArray[id].messages);
    }
    return res;
  }

  hasLive() {
    return Utils.cacheSync('conversations', 'hasLive', () => {
      let hasLive = false;
      this.forEach(conversation => {
        if (conversation.kind == 'one' && conversation.isLive())
          hasLive = true;
      });
      return hasLive;
    });
  }

  // Returns conversations as a list sorted according to the date of their last message chronologically
  toArray(includeTemp = false) {
    return Utils.cacheSync('conversations', 'toArray', () => {
      return Object.values(this._list).sort((conv1, conv2) => {
        conv1.last_activity > conv2.last_activity
      }).concat(includeTemp && this._temp_conversation ? [this._temp_conversation] : []);
    }).slice(0)
  }

  /**
   * get
   * @param  {number} i        Id of the conversation. Can be null.
   * @return {Conversation}    Can return null if
   *                               - No conversation exists for this id
   *                               - The id parameter is null and a new conversation can't be created
   */
  get(i) {
    if (i === null && this.temp_conversation) return this.temp_conversation;
    return this._list[i];
  }

  forEach(fct) {
    Utils.forEach(this._list, fct);
  }

  /* UNSORTED */

  keepScrollOnBottom(conversation = null, smooth = true, scrollBy = null) {
    if (!conversation || this.current == conversation && Views.didEventHappen('ready')) {
      let conversationView = Views.getByName('conversation');
      let scrollable = conversationView.getScrollableElement();
      if (conversationView.isScrollAtBottom()) {
        if (scrollBy != null) {
          conversationView.scrollBy(scrollBy);
        }
        else {
          conversationView.scrollToBottom(smooth);
        }
      }
    }
  }
});
